import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { delete_device as _delete_device, exchange_device as _exchange_device,
//设备更换
get_agency_list as _get_agency_list, get_script_list as _get_script_list, get_company_list as _get_company_list, get_cpe_template_agency as _get_cpe_template_agency, get_device_list, get_device_model as _get_device_model, move_device as _move_device, push_config as _push_config, update_cpe_template_agency, update_device as _update_device, batch_update_device as _batch_update_device, get_bgp as _get_bgp, create_bgp_normal as _create_bgp_normal, update_bgp_normal as _update_bgp_normal, delete_bgp_normal as _delete_bgp_normal, get_port_detect as _get_port_detect, create_port_detect as _create_port_detect, update_port_detect as _update_port_detect, delete_port_detect as _delete_port_detect, get_center_links_bandwidth_stat as _get_center_links_bandwidth_stat, push_config_old as _push_config_old, get_link_list as _get_link_list, update_link as _update_link, check_move_device as _check_move_device, all_company_update, get_wan_isp_info as _get_wan_isp_info, get_link_detect_info as _get_link_detect_info, create_link_detect_info as _create_link_detect_info, delete_link_detect_info as _delete_link_detect_info, get_agency_ip_of_device as _get_agency_ip_of_device, check_ip_in_agency_ip as _check_ip_in_agency_ip, get_agency_ip_of_link as _get_agency_ip_of_link, cstep_device_changed, create_script_file as _create_script_file, update_script_file as _update_script_file, delete_script_file as _delete_script_file, get_script_file as _get_script_file, create_reverse_tunnel as _create_reverse_tunnel, get_other_task as _get_other_task, delete_other_task as _delete_other_task, create_other_task as _create_other_task, push_all_config as _push_all_config, get_queue_task as _get_queue_task, purge_task as _purge_task } from "../../services/Company/companyS";
import { get_main_flow as _get_main_flow } from '../../services/rate/rateS';
import { get_alarm_list as _get_alarm_list } from "../../services/Alarm/alarmS";
import { BossMessage } from "../../components/Common/BossMessages";
import moment from 'moment';
export default {
  namespace: "ci0101Info",
  state: {
    agencyData: [],
    agencyDataStep: [],
    deviceData: [],
    companyInfo: {},
    ipTableList: [],
    deviceStat: {},
    INIT: 0,
    OFFLINE: 0,
    ONLINE: 0,
    alarmList: [],
    alertModalShow: false,
    popDeviceList: [],
    agencyList: [],
    total: 0,
    deviceModelList: [],
    cmdList: [],
    ctaList: [],
    companyList: [],
    wansList: [],
    lansList: [],
    bgpList: [],
    portList: [],
    deviceChartData: [],
    bandwidthData: {
      band_stat: [],
      total_count: '',
      total_bandwidth: ''
    },
    hcpeSpeedSeries: [],
    hasHcpeSpeed: false,
    deviceDataState: [],
    linkData: [],
    initPayload: {},
    deviceInfo: {},
    isCheckMoveDevice: true,
    ispInfo: [],
    linkDetectList: [],
    agencyIpList: [],
    checkIpInAgencyIp: {},
    agencyIpLinkList: [],
    cehckMoveErrorMsg: '',
    queueTaskList: []
  },
  effects: {
    get_agency_list: function get_agency_list(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(_get_agency_list, payload);
            case 2:
              backData = _context.sent;
              _context.next = 5;
              return put({
                type: "update",
                payload: {
                  agencyList: backData.result
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_cpe_template_agency: function get_cpe_template_agency(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_get_cpe_template_agency, payload);
            case 2:
              backData = _context2.sent;
              _context2.next = 5;
              return put({
                type: "update",
                payload: {
                  ctaList: backData.result
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    get_script_list: function get_script_list(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_get_script_list, payload);
            case 2:
              backData = _context3.sent;
              _context3.next = 5;
              return put({
                type: "update",
                payload: {
                  cmdList: backData.data && backData.data.list && Array.isArray(backData.data.list) ? backData.data.list.sort() : []
                }
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    get_device_model: function get_device_model(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_device_model, payload);
            case 2:
              backData = _context4.sent;
              _context4.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceModelList: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    exchange_device: function exchange_device(_ref9, _ref10) {
      var payload = _ref9.payload;
      var select = _ref10.select,
        call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_exchange_device, payload.update);
            case 2:
              backData = _context5.sent;
              _context5.next = 5;
              return select(function (state) {
                return state.ci0101Info.initPayload;
              });
            case 5:
              initPayload = _context5.sent;
              if (!backData.success) {
                _context5.next = 14;
                break;
              }
              BossMessage(true, "Device replacement successful");
              _context5.next = 10;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 10:
              _context5.next = 12;
              return put({
                type: "getDeviceList",
                payload: initPayload
              });
            case 12:
              _context5.next = 15;
              break;
            case 14:
              BossMessage(false, "Device replacement failed" + backData.result);
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    move_device: function move_device(_ref11, _ref12) {
      var payload = _ref11.payload;
      var select = _ref12.select,
        call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData, backData2, isCompany, initPayload;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_move_device, payload.update);
            case 2:
              backData = _context6.sent;
              backData2 = {};
              isCompany = sessionStorage.getItem("role") === "companystaff" || sessionStorage.getItem("role") === 'company';
              _context6.next = 7;
              return select(function (state) {
                return state.ci0101Info.initPayload;
              });
            case 7:
              initPayload = _context6.sent;
              if (!payload.update.cta_id) {
                _context6.next = 38;
                break;
              }
              if (!backData.success) {
                _context6.next = 14;
                break;
              }
              _context6.next = 12;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 12:
              _context6.next = 14;
              return call(all_company_update, {
                company_id: payload.update.target_company_id
              });
            case 14:
              if (!(payload.update.cta_id > 0)) {
                _context6.next = 20;
                break;
              }
              _context6.next = 17;
              return call(update_cpe_template_agency, {
                id: payload.update.cta_id,
                device_id: payload.update.id // bind:1
              });
            case 17:
              backData2 = _context6.sent;
              _context6.next = 21;
              break;
            case 20:
              backData2.success = true;
            case 21:
              if (!(backData.success && backData2.success)) {
                _context6.next = 35;
                break;
              }
              BossMessage(true, "Device migration successful");
              if (!(payload.update.type && payload.update.type === 'CSTEP')) {
                _context6.next = 31;
                break;
              }
              if (!isCompany) {
                _context6.next = 29;
                break;
              }
              _context6.next = 27;
              return call(cstep_device_changed, {
                sn: payload.initcompany && payload.initcompany.sn ? payload.initcompany.sn : '',
                company_id: payload.init.company_id
              });
            case 27:
              _context6.next = 31;
              break;
            case 29:
              _context6.next = 31;
              return call(cstep_device_changed, {
                sn: payload.initcompany && payload.initcompany.sn ? payload.initcompany.sn : ''
              });
            case 31:
              _context6.next = 33;
              return put({
                type: "getDeviceList",
                payload: initPayload
              });
            case 33:
              _context6.next = 36;
              break;
            case 35:
              BossMessage(false, "Device migration failed" + backData.result);
            case 36:
              _context6.next = 57;
              break;
            case 38:
              if (!backData.success) {
                _context6.next = 56;
                break;
              }
              BossMessage(true, "Device migration successful");
              _context6.next = 42;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 42:
              _context6.next = 44;
              return call(all_company_update, {
                company_id: payload.update.target_company_id
              });
            case 44:
              if (!(payload.update.type && payload.update.type === 'CSTEP')) {
                _context6.next = 52;
                break;
              }
              if (!isCompany) {
                _context6.next = 50;
                break;
              }
              _context6.next = 48;
              return call(cstep_device_changed, {
                sn: payload.initcompany && payload.initcompany.sn ? payload.initcompany.sn : '',
                company_id: payload.init.company_id
              });
            case 48:
              _context6.next = 52;
              break;
            case 50:
              _context6.next = 52;
              return call(cstep_device_changed, {
                sn: payload.initcompany && payload.initcompany.sn ? payload.initcompany.sn : ''
              });
            case 52:
              _context6.next = 54;
              return put({
                type: "getDeviceList",
                payload: initPayload
              });
            case 54:
              _context6.next = 57;
              break;
            case 56:
              BossMessage(false, "Device migration failed:" + backData.result);
            case 57:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    getCompanyList: function getCompanyList(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context7.sent;
              _context7.next = 5;
              return put({
                type: "update",
                payload: {
                  companyInfo: backData.result[0]
                }
              });
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    getDeviceList: function getDeviceList(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(get_device_list, payload);
            case 2:
              backData = _context8.sent;
              _context8.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceData: backData.result && Array.isArray(backData.result) ? backData.result : [],
                  total: backData.total,
                  INIT: backData.init,
                  OFFLINE: backData.offline,
                  ONLINE: backData.online,
                  initPayload: payload
                }
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    get_alarm_list: function get_alarm_list(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_get_alarm_list, payload);
            case 2:
              backData = _context9.sent;
              if (!(backData.result.length === 0)) {
                _context9.next = 7;
                break;
              }
              BossMessage(false, "No alarm for 24 hours");
              _context9.next = 9;
              break;
            case 7:
              _context9.next = 9;
              return put({
                type: "update",
                payload: {
                  alarmList: backData.result,
                  alertModalShow: true
                }
              });
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    closeAlertModal: function closeAlertModal(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return put({
                type: "update",
                payload: {
                  alertModalShow: false
                }
              });
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    delete_device: function delete_device(_ref21, _ref22) {
      var payload = _ref21.payload;
      var select = _ref22.select,
        call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(payload.initcompany && payload.initcompany.sn)) {
                _context11.next = 3;
                break;
              }
              _context11.next = 3;
              return call(cstep_device_changed, {
                sn: payload.initcompany.sn
              });
            case 3:
              _context11.next = 5;
              return call(_delete_device, payload["delete"]);
            case 5:
              backData = _context11.sent;
              _context11.next = 8;
              return select(function (state) {
                return state.ci0101Info.initPayload;
              });
            case 8:
              initPayload = _context11.sent;
              if (!backData.success) {
                _context11.next = 17;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context11.next = 13;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 13:
              _context11.next = 15;
              return put({
                type: "getDeviceList",
                payload: initPayload
              });
            case 15:
              _context11.next = 18;
              break;
            case 17:
              BossMessage(false, "Delete failed:" + backData.result);
            case 18:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    get_pop_device_list: function get_pop_device_list(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(get_device_list, payload);
            case 2:
              backData = _context12.sent;
              _context12.next = 5;
              return put({
                type: "update",
                payload: {
                  popDeviceList: backData.result
                }
              });
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    update_device: function update_device(_ref25, _ref26) {
      var payload = _ref25.payload;
      var select = _ref26.select,
        call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_update_device, payload.update);
            case 2:
              backData = _context13.sent;
              _context13.next = 5;
              return select(function (state) {
                return state.ci0101Info.initPayload;
              });
            case 5:
              initPayload = _context13.sent;
              if (!backData.success) {
                _context13.next = 14;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context13.next = 10;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 10:
              _context13.next = 12;
              return put({
                type: "getDeviceList",
                payload: initPayload
              });
            case 12:
              _context13.next = 15;
              break;
            case 14:
              BossMessage(false, "Modification failed:" + backData.result);
            case 15:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    push_config: function push_config(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_push_config, payload);
            case 2:
              backData = _context14.sent;
              if (backData.success) {
                BossMessage(true, "Successfully pushed");
              } else {
                BossMessage(false, "Push failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    push_config_old: function push_config_old(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_push_config_old, payload);
            case 2:
              backData = _context15.sent;
              if (backData.success) {
                BossMessage(true, "Successfully pushed");
              } else {
                BossMessage(false, "Push failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    get_company_list: function get_company_list(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context16.sent;
              _context16.next = 5;
              return put({
                type: "update",
                payload: {
                  companyList: backData.result || []
                }
              });
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    batch_update_device: function batch_update_device(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_batch_update_device, payload.update);
            case 2:
              backData = _context17.sent;
              if (!backData.success) {
                _context17.next = 9;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context17.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context17.next = 10;
              break;
            case 9:
              BossMessage(false, "Modification failed:" + backData.result);
            case 10:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    get_bgp: function get_bgp(_ref35, _ref36) {
      var payload = _ref35.payload;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_get_bgp, payload);
            case 2:
              backData = _context18.sent;
              _context18.next = 5;
              return put({
                type: "update",
                payload: {
                  bgpList: backData.result
                }
              });
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    create_bgp_normal: function create_bgp_normal(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_create_bgp_normal, payload.update);
            case 2:
              backData = _context19.sent;
              if (!backData.success) {
                _context19.next = 12;
                break;
              }
              BossMessage(true, "Successfully added");
              _context19.next = 7;
              return call(_get_bgp, {
                sn: payload.update.sn
              });
            case 7:
              backData1 = _context19.sent;
              _context19.next = 10;
              return put({
                type: "update",
                payload: {
                  bgpList: backData1.result
                }
              });
            case 10:
              _context19.next = 13;
              break;
            case 12:
              _Modal.error({
                title: backData.result
              });
            case 13:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    update_bgp_normal: function update_bgp_normal(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_update_bgp_normal, payload.update);
            case 2:
              backData = _context20.sent;
              if (!backData.success) {
                _context20.next = 12;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context20.next = 7;
              return call(_get_bgp, {
                sn: payload.update.sn
              });
            case 7:
              backData1 = _context20.sent;
              _context20.next = 10;
              return put({
                type: "update",
                payload: {
                  bgpList: backData1.result
                }
              });
            case 10:
              _context20.next = 13;
              break;
            case 12:
              BossMessage(false, "Modification failed:" + backData.result);
            case 13:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    },
    delete_bgp_normal: function delete_bgp_normal(_ref41, _ref42) {
      var payload = _ref41.payload;
      var call = _ref42.call,
        put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return call(_delete_bgp_normal, payload);
            case 2:
              backData = _context21.sent;
              if (!backData.success) {
                _context21.next = 12;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context21.next = 7;
              return call(_get_bgp, {
                sn: payload.sn
              });
            case 7:
              backData1 = _context21.sent;
              _context21.next = 10;
              return put({
                type: "update",
                payload: {
                  bgpList: backData1.result
                }
              });
            case 10:
              _context21.next = 13;
              break;
            case 12:
              BossMessage(false, "Delete failed:" + backData.result);
            case 13:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      })();
    },
    get_port_detect: function get_port_detect(_ref43, _ref44) {
      var payload = _ref43.payload;
      var call = _ref44.call,
        put = _ref44.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_get_port_detect, payload);
            case 2:
              backData = _context22.sent;
              _context22.next = 5;
              return put({
                type: "update",
                payload: {
                  portList: backData.result
                }
              });
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      })();
    },
    create_port_detect: function create_port_detect(_ref45, _ref46) {
      var payload = _ref45.payload;
      var call = _ref46.call,
        put = _ref46.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return call(_create_port_detect, payload.update);
            case 2:
              backData = _context23.sent;
              if (!backData.success) {
                _context23.next = 14;
                break;
              }
              BossMessage(true, "Successfully added");
              _context23.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context23.next = 9;
              return call(_get_port_detect, {
                device_id: payload.update.device_id
              });
            case 9:
              backData1 = _context23.sent;
              _context23.next = 12;
              return put({
                type: "update",
                payload: {
                  portList: backData1.result
                }
              });
            case 12:
              _context23.next = 15;
              break;
            case 14:
              _Modal.error({
                title: backData.result
              });
            case 15:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      })();
    },
    update_port_detect: function update_port_detect(_ref47, _ref48) {
      var payload = _ref47.payload;
      var call = _ref48.call,
        put = _ref48.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return call(_update_port_detect, payload.update);
            case 2:
              backData = _context24.sent;
              if (!backData.success) {
                _context24.next = 14;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context24.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context24.next = 9;
              return call(_get_port_detect, {
                device_id: payload.update.device_id
              });
            case 9:
              backData1 = _context24.sent;
              _context24.next = 12;
              return put({
                type: "update",
                payload: {
                  portList: backData1.result
                }
              });
            case 12:
              _context24.next = 15;
              break;
            case 14:
              BossMessage(false, "Modification failed:" + backData.result);
            case 15:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      })();
    },
    delete_port_detect: function delete_port_detect(_ref49, _ref50) {
      var payload = _ref49.payload;
      var call = _ref50.call,
        put = _ref50.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return call(_delete_port_detect, payload.update);
            case 2:
              backData = _context25.sent;
              if (!backData.success) {
                _context25.next = 14;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context25.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context25.next = 9;
              return call(_get_port_detect, {
                device_id: payload.update.device_id
              });
            case 9:
              backData1 = _context25.sent;
              _context25.next = 12;
              return put({
                type: "update",
                payload: {
                  portList: backData1.result
                }
              });
            case 12:
              _context25.next = 15;
              break;
            case 14:
              BossMessage(false, "Delete failed:" + backData.result);
            case 15:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      })();
    },
    get_center_links_bandwidth_stat: function get_center_links_bandwidth_stat(_ref51, _ref52) {
      var payload = _ref51.payload;
      var call = _ref52.call,
        put = _ref52.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var backData, band_stat;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return call(_get_center_links_bandwidth_stat, payload);
            case 2:
              backData = _context26.sent;
              band_stat = [];
              band_stat.push({
                name: '<10',
                value: backData.stat['<10']
              });
              band_stat.push({
                name: '10-50',
                value: backData.stat['10-50']
              });
              band_stat.push({
                name: '50-100',
                value: backData.stat['50-100']
              });
              band_stat.push({
                name: '>=100',
                value: backData.stat['>=100']
              });
              _context26.next = 10;
              return put({
                type: "update",
                payload: {
                  bandwidthData: _objectSpread({}, backData, {
                    band_stat: band_stat
                  })
                }
              });
            case 10:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      })();
    },
    get_main_flow: function get_main_flow(_ref53, _ref54) {
      var payload = _ref53.payload;
      var call = _ref54.call,
        put = _ref54.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var backData, hasHcpeSpeed, speedSeries, seriesTx, seriesRx, key, data, time;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return call(_get_main_flow, payload);
            case 2:
              backData = _context27.sent;
              hasHcpeSpeed = false;
              speedSeries = [];
              seriesTx = {
                name: "Uplink rate",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#3B9FF7"
                },
                itemStyle: {
                  color: "#3B9FF7"
                }
              };
              seriesRx = {
                name: "Downlink rate",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#D396F5"
                },
                itemStyle: {
                  color: "#D396F5"
                }
              };
              if (backData.msg === "ok" || backData.retcode === 0) {
                for (key in backData.data) {
                  data = backData.data[key];
                  time = moment.unix(backData.data[key].time).format("YYYY-MM-DD HH:mm:ss");
                  seriesRx.data.push([time, (data.raterx * 8 / 1024).toFixed(4)]);
                  seriesTx.data.push([time, (data.ratetx * 8 / 1024).toFixed(4)]);
                }
                if (backData.data.length > 0) {
                  hasHcpeSpeed = true;
                }
              }
              speedSeries.push(seriesRx);
              speedSeries.push(seriesTx);
              _context27.next = 12;
              return put({
                type: "update",
                payload: {
                  hcpeSpeedSeries: speedSeries,
                  hasHcpeSpeed: hasHcpeSpeed
                }
              });
            case 12:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      })();
    },
    get_link_list: function get_link_list(_ref55, _ref56) {
      var payload = _ref55.payload;
      var call = _ref56.call,
        put = _ref56.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context28.sent;
              _context28.next = 5;
              return put({
                type: "update",
                payload: {
                  linkData: backData.result
                }
              });
            case 5:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      })();
    },
    update_link: function update_link(_ref57, _ref58) {
      var payload = _ref57.payload;
      var call = _ref58.call,
        put = _ref58.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return call(_update_link, payload.update);
            case 2:
              backData = _context29.sent;
              if (!backData.success) {
                _context29.next = 9;
                break;
              }
              BossMessage(true, "Operation successful");
              _context29.next = 7;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 7:
              _context29.next = 10;
              break;
            case 9:
              BossMessage(false, "Operation failed:" + backData.result);
            case 10:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      })();
    },
    get_device_info: function get_device_info(_ref59, _ref60) {
      var payload = _ref59.payload;
      var call = _ref60.call,
        put = _ref60.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return call(get_device_list, payload);
            case 2:
              backData = _context30.sent;
              _context30.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceInfo: backData.result[0]
                }
              });
            case 5:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      })();
    },
    check_move_device: function check_move_device(_ref61, _ref62) {
      var payload = _ref61.payload;
      var call = _ref62.call,
        put = _ref62.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return call(_check_move_device, payload);
            case 2:
              backData = _context31.sent;
              if (!(backData.retcode !== 0)) {
                _context31.next = 14;
                break;
              }
              if (!(backData.retcode === 2)) {
                _context31.next = 9;
                break;
              }
              _context31.next = 7;
              return put({
                type: "update",
                payload: {
                  isCheckMoveDevice: true,
                  cehckMoveErrorMsg: backData.msg
                }
              });
            case 7:
              _context31.next = 12;
              break;
            case 9:
              _context31.next = 11;
              return put({
                type: "update",
                payload: {
                  isCheckMoveDevice: false,
                  cehckMoveErrorMsg: ''
                }
              });
            case 11:
              BossMessage(false, backData.msg);
            case 12:
              _context31.next = 16;
              break;
            case 14:
              _context31.next = 16;
              return put({
                type: "update",
                payload: {
                  isCheckMoveDevice: true,
                  cehckMoveErrorMsg: ''
                }
              });
            case 16:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      })();
    },
    get_wan_isp_info: function get_wan_isp_info(_ref63, _ref64) {
      var payload = _ref63.payload;
      var call = _ref64.call,
        put = _ref64.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return call(_get_wan_isp_info, payload);
            case 2:
              backData = _context32.sent;
              _context32.next = 5;
              return put({
                type: "update",
                payload: {
                  ispInfo: backData.data && backData.data.list ? backData.data.list : []
                }
              });
            case 5:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      })();
    },
    get_link_detect_info: function get_link_detect_info(_ref65, _ref66) {
      var payload = _ref65.payload;
      var call = _ref66.call,
        put = _ref66.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return call(_get_link_detect_info, payload);
            case 2:
              backData = _context33.sent;
              _context33.next = 5;
              return put({
                type: "update",
                payload: {
                  linkDetectList: backData.data && backData.data.list ? backData.data.list : []
                }
              });
            case 5:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      })();
    },
    delete_link_detect_info: function delete_link_detect_info(_ref67, _ref68) {
      var payload = _ref67.payload;
      var call = _ref68.call,
        put = _ref68.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return call(_delete_link_detect_info, payload.update);
            case 2:
              backData = _context34.sent;
              if (!(backData.retcode === 0)) {
                _context34.next = 12;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context34.next = 7;
              return call(_get_link_detect_info, {
                sn: payload.init.sn
              });
            case 7:
              backData1 = _context34.sent;
              _context34.next = 10;
              return put({
                type: "update",
                payload: {
                  linkDetectList: backData1.data && backData1.data.list ? backData1.data.list : []
                }
              });
            case 10:
              _context34.next = 13;
              break;
            case 12:
              BossMessage(false, "Delete failed:" + backData.msg);
            case 13:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      })();
    },
    create_link_detect_info: function create_link_detect_info(_ref69, _ref70) {
      var payload = _ref69.payload;
      var call = _ref70.call,
        put = _ref70.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return call(_create_link_detect_info, payload.update);
            case 2:
              backData = _context35.sent;
              if (!(backData.retcode === 0)) {
                _context35.next = 12;
                break;
              }
              BossMessage(true, "Successfully sent");
              _context35.next = 7;
              return call(_get_link_detect_info, {
                sn: payload.init.sn
              });
            case 7:
              backData1 = _context35.sent;
              _context35.next = 10;
              return put({
                type: "update",
                payload: {
                  linkDetectList: backData1.data && backData1.data.list ? backData1.data.list : []
                }
              });
            case 10:
              _context35.next = 13;
              break;
            case 12:
              BossMessage(false, "Sending failed:" + backData.msg);
            case 13:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      })();
    },
    get_agency_ip_of_device: function get_agency_ip_of_device(_ref71, _ref72) {
      var payload = _ref71.payload;
      var call = _ref72.call,
        put = _ref72.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return call(_get_agency_ip_of_device, payload);
            case 2:
              backData = _context36.sent;
              _context36.next = 5;
              return put({
                type: "update",
                payload: {
                  agencyIpList: backData.data && backData.data.list ? backData.data.list : []
                }
              });
            case 5:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      })();
    },
    check_ip_in_agency_ip: function check_ip_in_agency_ip(_ref73, _ref74) {
      var payload = _ref73.payload;
      var call = _ref74.call,
        put = _ref74.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return call(_check_ip_in_agency_ip, payload);
            case 2:
              backData = _context37.sent;
              _context37.next = 5;
              return put({
                type: "update",
                payload: {
                  checkIpInAgencyIp: backData
                }
              });
            case 5:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      })();
    },
    get_agency_ip_of_link: function get_agency_ip_of_link(_ref75, _ref76) {
      var payload = _ref75.payload;
      var call = _ref76.call,
        put = _ref76.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return call(_get_agency_ip_of_link, payload);
            case 2:
              backData = _context38.sent;
              _context38.next = 5;
              return put({
                type: "update",
                payload: {
                  agencyIpLinkList: backData.data && backData.data.list ? backData.data.list : []
                }
              });
            case 5:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      })();
    },
    create_script_file: function create_script_file(_ref77, _ref78) {
      var payload = _ref77.payload;
      var call = _ref78.call,
        put = _ref78.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return call(_create_script_file, payload.update);
            case 2:
              backData = _context39.sent;
              if (!(backData.retcode === 0)) {
                _context39.next = 9;
                break;
              }
              BossMessage(true, "Successfully added");
              _context39.next = 7;
              return put({
                type: "get_script_list",
                payload: {}
              });
            case 7:
              _context39.next = 10;
              break;
            case 9:
              _Modal.error({
                title: backData.result
              });
            case 10:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      })();
    },
    update_script_file: function update_script_file(_ref79, _ref80) {
      var payload = _ref79.payload;
      var call = _ref80.call,
        put = _ref80.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return call(_update_script_file, payload.update);
            case 2:
              backData = _context40.sent;
              if (!(backData.retcode === 0)) {
                _context40.next = 9;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context40.next = 7;
              return put({
                type: "get_script_list",
                payload: {}
              });
            case 7:
              _context40.next = 10;
              break;
            case 9:
              BossMessage(false, "Modification failed:" + backData.result);
            case 10:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      })();
    },
    delete_script_file: function delete_script_file(_ref81, _ref82) {
      var payload = _ref81.payload;
      var call = _ref82.call,
        put = _ref82.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return call(_delete_script_file, payload);
            case 2:
              backData = _context41.sent;
              if (!(backData.retcode === 0)) {
                _context41.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context41.next = 7;
              return put({
                type: "get_script_list",
                payload: {}
              });
            case 7:
              _context41.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed:" + backData.result);
            case 10:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      })();
    },
    get_script_file: function get_script_file(_ref83, _ref84) {
      var payload = _ref83.payload,
        callback = _ref83.callback;
      var call = _ref84.call,
        put = _ref84.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return call(_get_script_file, payload);
            case 2:
              backData = _context42.sent;
              if (callback && typeof callback === 'function') {
                callback(backData);
              }
            case 4:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      })();
    },
    create_reverse_tunnel: function create_reverse_tunnel(_ref85, _ref86) {
      var payload = _ref85.payload,
        callback = _ref85.callback;
      var call = _ref86.call,
        put = _ref86.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return call(_create_reverse_tunnel, payload);
            case 2:
              backData = _context43.sent;
              if (callback && typeof callback === 'function') {
                callback(backData);
              }
            case 4:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      })();
    },
    get_other_task: function get_other_task(_ref87, _ref88) {
      var payload = _ref87.payload,
        callback = _ref87.callback;
      var call = _ref88.call,
        put = _ref88.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return call(_get_other_task, payload);
            case 2:
              backData = _context44.sent;
              if (callback && typeof callback === 'function') {
                callback(backData);
              }
            case 4:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      })();
    },
    create_other_task: function create_other_task(_ref89, _ref90) {
      var payload = _ref89.payload;
      var call = _ref90.call,
        put = _ref90.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return call(_create_other_task, payload.update);
            case 2:
              backData = _context45.sent;
              if (!(backData.retcode === 0)) {
                _context45.next = 9;
                break;
              }
              BossMessage(true, "Operation successful");
              _context45.next = 7;
              return put({
                type: "get_other_task",
                payload: {
                  sn: payload.update.sn
                }
              });
            case 7:
              _context45.next = 10;
              break;
            case 9:
              BossMessage(false, "Operation failed:" + backData.message);
            case 10:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      })();
    },
    delete_other_task: function delete_other_task(_ref91, _ref92) {
      var payload = _ref91.payload;
      var call = _ref92.call,
        put = _ref92.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return call(_delete_other_task, payload.update);
            case 2:
              backData = _context46.sent;
              if (!(backData.retcode === 0)) {
                _context46.next = 9;
                break;
              }
              BossMessage(true, "Operation successful");
              _context46.next = 7;
              return put({
                type: "get_other_task",
                payload: {
                  sn: payload.update.sn
                }
              });
            case 7:
              _context46.next = 10;
              break;
            case 9:
              BossMessage(false, "Operation failed:" + backData.message);
            case 10:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      })();
    },
    push_all_config: function push_all_config(_ref93, _ref94) {
      var payload = _ref93.payload;
      var call = _ref94.call,
        put = _ref94.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 2;
              return call(_push_all_config, payload);
            case 2:
              backData = _context47.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Operation successful");
              } else {
                BossMessage(false, "Operation failed:" + backData.message);
              }
            case 4:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      })();
    },
    get_queue_task: function get_queue_task(_ref95, _ref96) {
      var payload = _ref95.payload;
      var call = _ref96.call,
        put = _ref96.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return call(_get_queue_task, payload);
            case 2:
              backData = _context48.sent;
              _context48.next = 5;
              return put({
                type: "update",
                payload: {
                  queueTaskList: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context48.stop();
          }
        }, _callee48);
      })();
    },
    purge_task: function purge_task(_ref97, _ref98) {
      var payload = _ref97.payload;
      var call = _ref98.call,
        put = _ref98.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _context49.next = 2;
              return call(_purge_task, payload);
            case 2:
              backData = _context49.sent;
              if (!backData.success) {
                _context49.next = 9;
                break;
              }
              BossMessage(true, "Operation successful");
              _context49.next = 7;
              return put({
                type: "get_queue_task",
                payload: payload
              });
            case 7:
              _context49.next = 10;
              break;
            case 9:
              BossMessage(false, "Operation failed:" + backData.result);
            case 10:
            case "end":
              return _context49.stop();
          }
        }, _callee49);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};